import React from 'react';
import axios from 'axios';
import Config from '../shared/Config';
import { handlerApiError } from '../shared/errorHandler';

const { apiBaseUrl } = Config();
const endpointUrl = `${apiBaseUrl}/api/templates`;
const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

let cacheTemplates = null;

export default function useTemplates() {
  const access_token = window.sessionStorage.getItem('token');
  headers.Authorization = `Bearer ${access_token}`;
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const getTemplates = (config) => {
    config.url = endpointUrl;
    axios(config)
      .then((response) => {
        const { data } = response;
        console.log('getTemplates: fetch', { data });
        setItems(data);
        cacheTemplates = data;
        setLoading(false);
      })
      .catch((err) => handlerApiError(err));
  };

  React.useEffect(() => {
    const config = { url: endpointUrl, headers };
    if (cacheTemplates) {
      setItems(cacheTemplates);
      setLoading(false);
    } else {
      getTemplates(config);
    }
  }, []);

  return { loading, items };
}
